// extracted by mini-css-extract-plugin
export var cardArrow = "entry-card-module--card-arrow--78c5f";
export var cardImage = "entry-card-module--card-image--48e17";
export var cardLink = "entry-card-module--card-link--119a9";
export var cardTitle = "entry-card-module--card-title--88b6d";
export var cardWrapper = "entry-card-module--card-wrapper--6a23f";
export var primary = "entry-card-module--primary--b89e3";
export var secondary = "entry-card-module--secondary--613b4";
export var tertiary = "entry-card-module--tertiary--f0b5b";